// 筛选类型常量
export const FILTER_TYPES = {
  MULTI_SELECT: 'multi_select',    // 多选
  SINGLE_SELECT: 'single_select',  // 单选
  DATE_RANGE: 'date_range',        // 日期范围
  NUMBER_RANGE: 'number_range',    // 数值范围
  BOOLEAN: 'boolean',              // 布尔值
};

// 国籍选项
const NATIONALITY_OPTIONS = [
  { value: '中国', label: '中国' },
  { value: '韓国', label: '韓国' },
  { value: 'ミャンマー', label: 'ミャンマー' },
  { value: 'インドネシア', label: 'インドネシア' },
  { value: 'ベトナム', label: 'ベトナム' },
  { value: 'フィリピン', label: 'フィリピン' },
];

// 工作领域选项
const WORK_FIELD_OPTIONS = [
  { value: '外食', label: '外食' },
  { value: '飲食料品製造', label: '飲食料品製造' },
  { value: '溶接', label: '溶接' },
  { value: '介護', label: '介護' },
  { value: '他', label: '他' },
];

// 就业状态选项
const EMPLOYMENT_STATUS_OPTIONS = [
  { value: 'すべて', label: 'すべて' },
  { value: '内定', label: '内定' },
  { value: '申請中', label: '申請中' },
  { value: '在職', label: '在職' },
  { value: '離職', label: '離職' },
  { value: '待入国', label: '待入社' },
];

const RESIDENCE_EMPLOYMENT_STATUS_OPTIONS = EMPLOYMENT_STATUS_OPTIONS
  .filter(option => option.value !== 'すべて');

const RESIDENCE_EMPLOYMENT_STATUS_PRESETS = [
  { label: 'すべて', value: [] },
  { label: '離職以外', value: ['内定', '申請中', '在職', '待入国'] },
  { label: '離職のみ', value: ['離職'] },
];

const SHORT_TERM_RESIGNATION_OPTIONS = [
  { value: '', label: 'すべて' },
  { value: '90', label: '90日以内' },
  { value: '180', label: '180日以内' },
];

// 性别选项
const GENDER_OPTIONS = [
  { value: 'すべて', label: 'すべて' },
  { value: '男', label: '男' },
  { value: '女', label: '女' },
];

// 编辑状态选项（Residence专用）
const EDIT_STATUS_OPTIONS = [
  { value: 'すべて', label: 'すべて' },
  { value: '編集済み', label: '編集済み' },
  { value: '未編集', label: '未編集' },
];

// 贷出状态选项（Accounting专用）
const LOAN_STATUS_OPTIONS = [
  { value: 'すべて', label: 'すべて' },
  { value: '貸出登録済み', label: '貸出登録済み' },
  { value: '未登録', label: '未登録' },
];

// 还款状态选项（Accounting专用）
const REPAYMENT_STATUS_OPTIONS = [
  { value: 'すべて', label: 'すべて' },
  { value: '完全返済済み', label: '完全返済済み' },
  { value: '未完済', label: '未完済' },
];

// 在留卡到期快捷筛选
const RESIDENCE_EXPIRY_QUICK_FILTERS = [
  { value: 'expiring_soon_30', label: '30日以内に期限切れ' },
  { value: 'expiring_soon_60', label: '60日以内に期限切れ' },
  { value: 'expiring_soon_90', label: '90日以内に期限切れ' },
  { value: 'expired', label: '期限切れ' },
  { value: 'renewal_pending', label: '更新申請中' },
];

// Admin角色的筛选配置
const ADMIN_FILTERS = [
  {
    id: 'nationalities',
    label: '国籍',
    type: FILTER_TYPES.MULTI_SELECT,
    options: NATIONALITY_OPTIONS,
    showCount: false,
  },
  {
    id: 'workFields',
    label: '作業分野',
    type: FILTER_TYPES.MULTI_SELECT,
    options: WORK_FIELD_OPTIONS,
    showCount: false,
  },
  {
    id: 'employmentStatus',
    label: '進歩状況',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: EMPLOYMENT_STATUS_OPTIONS,
  },
  {
    id: 'employmentStatusDate',
    label: '進歩状況日付',
    type: FILTER_TYPES.DATE_RANGE,
  },
  {
    id: 'employmentDurationMaxDays',
    label: '短期離職',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: SHORT_TERM_RESIGNATION_OPTIONS,
  },
  {
    id: 'gender',
    label: '性別',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: GENDER_OPTIONS,
  },
  {
    id: 'managementFee',
    label: '管理費',
    type: FILTER_TYPES.NUMBER_RANGE,
    unit: '円',
    minInputValue: 1,
    noChargeFilterId: 'managementFeeNotCharged',
    noChargeLabel: '無償',
    unregisteredFilterId: 'managementFeeUnregistered',
    unregisteredLabel: '未登記',
  },
  {
    id: 'initialCost',
    label: '初期費用',
    type: FILTER_TYPES.NUMBER_RANGE,
    unit: '円',
    minInputValue: 1,
    noChargeFilterId: 'initialCostNotCharged',
    noChargeLabel: '無償',
    unregisteredFilterId: 'initialCostUnregistered',
    unregisteredLabel: '未登記',
  },
  {
    id: 'salesStaffId',
    label: '責任営業',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: [{ value: '', label: 'すべて' }], // 动态加载
    dynamic: true, // 标记为动态字段
  },
  {
    id: 'residenceCardExpiry',
    label: '在留カード期限',
    type: FILTER_TYPES.DATE_RANGE,
    quickFilters: RESIDENCE_EXPIRY_QUICK_FILTERS,
  },
];

// Sales角色的筛选配置（不包括责任营业筛选，因为只能看自己的人才）
const SALES_FILTERS = [
  {
    id: 'nationalities',
    label: '国籍',
    type: FILTER_TYPES.MULTI_SELECT,
    options: NATIONALITY_OPTIONS,
    showCount: false,
  },
  {
    id: 'workFields',
    label: '作業分野',
    type: FILTER_TYPES.MULTI_SELECT,
    options: WORK_FIELD_OPTIONS,
    showCount: false,
  },
  {
    id: 'employmentStatus',
    label: '進歩状況',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: EMPLOYMENT_STATUS_OPTIONS,
  },
  {
    id: 'employmentStatusDate',
    label: '進歩状況日付',
    type: FILTER_TYPES.DATE_RANGE,
  },
  {
    id: 'gender',
    label: '性別',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: GENDER_OPTIONS,
  },
  {
    id: 'managementFee',
    label: '管理費',
    type: FILTER_TYPES.NUMBER_RANGE,
    unit: '円',
    minInputValue: 1,
    noChargeFilterId: 'managementFeeNotCharged',
    noChargeLabel: '無償',
    unregisteredFilterId: 'managementFeeUnregistered',
    unregisteredLabel: '未登記',
  },
  {
    id: 'initialCost',
    label: '初期費用',
    type: FILTER_TYPES.NUMBER_RANGE,
    unit: '円',
    minInputValue: 1,
    noChargeFilterId: 'initialCostNotCharged',
    noChargeLabel: '無償',
    unregisteredFilterId: 'initialCostUnregistered',
    unregisteredLabel: '未登記',
  },
  {
    id: 'residenceCardExpiry',
    label: '在留カード期限',
    type: FILTER_TYPES.DATE_RANGE,
    quickFilters: RESIDENCE_EXPIRY_QUICK_FILTERS,
  },
];

// Residence角色的筛选配置
const RESIDENCE_FILTERS = [
  {
    id: 'nationalities',
    label: '国籍',
    type: FILTER_TYPES.MULTI_SELECT,
    options: NATIONALITY_OPTIONS,
    showCount: false,
  },
  {
    id: 'employmentStatuses',
    label: '進歩状況',
    type: FILTER_TYPES.MULTI_SELECT,
    options: RESIDENCE_EMPLOYMENT_STATUS_OPTIONS,
    quickPresets: RESIDENCE_EMPLOYMENT_STATUS_PRESETS,
    showCount: false,
  },
  {
    id: 'editStatus',
    label: '編集状態',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: EDIT_STATUS_OPTIONS,
  },
  {
    id: 'residenceCardExpiry',
    label: '在留カード期限',
    type: FILTER_TYPES.DATE_RANGE,
    quickFilters: RESIDENCE_EXPIRY_QUICK_FILTERS,
  },
];

// Accounting角色的筛选配置
const ACCOUNTING_FILTERS = [
  {
    id: 'nationalities',
    label: '国籍',
    type: FILTER_TYPES.MULTI_SELECT,
    options: NATIONALITY_OPTIONS,
    showCount: false,
  },
  {
    id: 'salesStaffId',
    label: '営業担当',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: [{ value: '', label: 'すべて' }],
    dynamic: true,
  },
  {
    id: 'loanStatus',
    label: '貸出状態',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: LOAN_STATUS_OPTIONS,
  },
  {
    id: 'repaymentStatus',
    label: '返済状態',
    type: FILTER_TYPES.SINGLE_SELECT,
    options: REPAYMENT_STATUS_OPTIONS,
  },
  {
    id: 'loanBalance',
    label: '残高',
    type: FILTER_TYPES.NUMBER_RANGE,
    unit: '円',
  },
];

// 根据角色获取筛选配置
export const getFilterConfigByRole = (role) => {
  switch (role) {
    case 'Admin':
    case 'SuperAdmin':
      return ADMIN_FILTERS;
    case 'Sales':
      return SALES_FILTERS;
    case 'Residence':
      return RESIDENCE_FILTERS;
    case 'Accounting':
      return ACCOUNTING_FILTERS;
    default:
      return [];
  }
};

// 获取初始筛选状态
export const getInitialFilters = (config) => {
  const initialFilters = {};

  config.forEach(field => {
    switch (field.type) {
      case FILTER_TYPES.MULTI_SELECT:
        initialFilters[field.id] = [];
        break;
      case FILTER_TYPES.SINGLE_SELECT:
        initialFilters[field.id] = field.options[0]?.value || '';
        break;
      case FILTER_TYPES.DATE_RANGE:
        initialFilters[field.id] = { start: '', end: '', renewalPending: false };
        break;
      case FILTER_TYPES.NUMBER_RANGE:
        initialFilters[field.id] = { min: '', max: '' };
        if (field.noChargeFilterId) {
          initialFilters[field.noChargeFilterId] = null;
        }
        if (field.unregisteredFilterId) {
          initialFilters[field.unregisteredFilterId] = null;
        }
        break;
      case FILTER_TYPES.BOOLEAN:
        initialFilters[field.id] = field.options[0]?.value || null;
        break;
      default:
        initialFilters[field.id] = null;
    }
  });

  return initialFilters;
};

// 检查是否有激活的筛选
export const hasActiveFilters = (filters, config) => {
  return config.some(field => {
    const value = filters[field.id];

    switch (field.type) {
      case FILTER_TYPES.MULTI_SELECT:
        return Array.isArray(value) && value.length > 0;
      case FILTER_TYPES.SINGLE_SELECT:
        return value !== '' && value !== field.options[0]?.value;
      case FILTER_TYPES.DATE_RANGE:
        return value.start !== '' || value.end !== '' || value.renewalPending === true;
      case FILTER_TYPES.NUMBER_RANGE:
      {
        const hasNoCharge = field.noChargeFilterId
          ? filters[field.noChargeFilterId] === true
          : false;
        const hasUnregistered = field.unregisteredFilterId
          ? filters[field.unregisteredFilterId] === true
          : false;
        return value.min !== '' || value.max !== '' || hasNoCharge || hasUnregistered;
      }
      case FILTER_TYPES.BOOLEAN:
        return value !== null && value !== field.options[0]?.value;
      default:
        return false;
    }
  });
};

// 获取激活的筛选数量
export const getActiveFilterCount = (filters, config) => {
  let count = 0;

  config.forEach(field => {
    const value = filters[field.id];

    switch (field.type) {
      case FILTER_TYPES.MULTI_SELECT:
        if (Array.isArray(value) && value.length > 0) count++;
        break;
      case FILTER_TYPES.SINGLE_SELECT:
        if (value !== '' && value !== field.options[0]?.value) count++;
        break;
      case FILTER_TYPES.DATE_RANGE:
        if (value.start !== '' || value.end !== '' || value.renewalPending === true) count++;
        break;
      case FILTER_TYPES.NUMBER_RANGE:
      {
        const hasNoCharge = field.noChargeFilterId
          ? filters[field.noChargeFilterId] === true
          : false;
        const hasUnregistered = field.unregisteredFilterId
          ? filters[field.unregisteredFilterId] === true
          : false;
        if (value.min !== '' || value.max !== '' || hasNoCharge || hasUnregistered) count++;
        break;
      }
      case FILTER_TYPES.BOOLEAN:
        if (value !== null && value !== field.options[0]?.value) count++;
        break;
      default:
        break;
    }
  });

  return count;
};

// 转换筛选为API参数
export const filtersToApiParams = (filters) => {
  const params = {};
  const excludedRangeFilterMap = {
    managementFee: ['managementFeeNotCharged', 'managementFeeUnregistered'],
    initialCost: ['initialCostNotCharged', 'initialCostUnregistered'],
  };

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // 多选：转为逗号分隔的字符串
      if (value.length > 0) {
        params[key] = value.join(',');
      }
    } else if (typeof value === 'object' && value !== null) {
      // 范围类型
      if ('start' in value && 'end' in value) {
        // 日期范围
        if (value.start) params[`${key}Start`] = value.start;
        if (value.end) params[`${key}End`] = value.end;
        // 更新申请中特殊筛选
        if (value.renewalPending === true) params['renewalPending'] = 'true';
      } else if ('min' in value && 'max' in value) {
        const excludedFilterKeys = excludedRangeFilterMap[key] || [];
        const hasExcludedFilter = excludedFilterKeys.some(filterKey => filters[filterKey] === true);
        if (hasExcludedFilter) {
          return;
        }
        // 数值范围
        if (value.min !== '') params[`${key}Min`] = value.min;
        if (value.max !== '') params[`${key}Max`] = value.max;
      }
    } else if (value !== '' && value !== 'すべて' && value !== null) {
      // 单选或其他类型
      params[key] = value;
    }
  });

  return params;
};
